import { createContext, useContext, type ReactNode } from 'react';
import type { Resource } from '../types';

interface MdtNavigationContextValue {
  changeUnit: () => Promise<void>;
  updateResource: (resource: Resource) => void;
}

const MdtNavigationContext = createContext<MdtNavigationContextValue | null>(null);

export function MdtNavigationProvider({
  children,
  changeUnit,
  updateResource,
}: {
  children: ReactNode;
  changeUnit: () => Promise<void>;
  updateResource: (resource: Resource) => void;
}) {
  return (
    <MdtNavigationContext.Provider value={{ changeUnit, updateResource }}>
      {children}
    </MdtNavigationContext.Provider>
  );
}

export function useMdtNavigation() {
  const ctx = useContext(MdtNavigationContext);
  if (!ctx) {
    throw new Error('useMdtNavigation must be used within MdtNavigationProvider');
  }
  return ctx;
}
